import {
    Antonio,
    type AntonioError,
    type RequestBodyData,
    type RequestConfig,
    type RequestHeaders,
    type RequestMethod,
    type RequestResult,
} from '@ackee/antonio-core';

import config from '@/config';

export type FetcherProps = RequestConfig & {
    url: string;
    method: RequestMethod;
    data?: RequestBodyData;
};

export type FetcherOptions = Omit<RequestConfig, 'data' | 'url' | 'method'>;

const apiClient = new Antonio({
    baseURL: config.api.base,
    headers: {
        Accept: 'application/json',
    },
});

export const api = () => apiClient;

function mergeHeaders(requestHeaders: RequestHeaders = {}, optionsHeaders: RequestHeaders = {}): Headers {
    const headers = new Headers();

    Object.entries(requestHeaders).forEach(([key, value]) => {
        headers.set(key, value);
    });

    Object.entries(optionsHeaders).forEach(([key, value]) => {
        headers.set(key, value);
    });

    return headers;
}

export function createApiRequest<T>(props: FetcherProps, options?: FetcherOptions): Promise<RequestResult<T>> {
    const { data, ...requestConfig } = props;
    const headers = mergeHeaders(requestConfig.headers, options?.headers);

    // !!! Never set Content-Type for multipart/form-data, let the browser set it automatically. The browser will also set the boundary automatically.
    if (headers.get('Content-Type') === 'multipart/form-data') {
        headers.delete('Content-Type');
    }

    return api().request<FetcherProps['method'], T, AntonioError<T>>({
        ...requestConfig,
        ...options,
        headers,
        body: data,
        credentials: 'omit',
    });
}

export type CreateApiRequest<T> = typeof createApiRequest<T>;
